import { render, staticRenderFns } from "./MarketplaceRatesTable.vue?vue&type=template&id=2e437af8&scoped=true"
import script from "./MarketplaceRatesTable.vue?vue&type=script&lang=js"
export * from "./MarketplaceRatesTable.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceRatesTable.vue?vue&type=style&index=0&id=2e437af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e437af8",
  null
  
)

export default component.exports